// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPipHistory} from '../../shared/repositories';

export const resetReport = () => ({
    type: actions.RESET_PIP_HISTORY_REPORT
});

export const readPipHistory = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPipHistory(pin);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.UPDATE_PIP_HISTORY_REPORT
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/pip-history/action-creators/report.js